const initialState = {
    // Status polling
    whatsAppStatus: {},
    isFetchingWhatsAppStatus: false,

    // Send single message
    sendMessageResponse: {},
    isSendingWhatsAppMessage: false,

    // Send bulk
    bulkMessageResults: [],
    isSendingBulkWhatsApp: false,

    // Real-time socket state
    socketStatus: "disconnected",   // 'disconnected' | 'qr' | 'connecting' | 'connected'
    socketMessage: "",
    qrCode: null,                   // base64 data-URL string, null when not needed
};

const WhatsAppReducer = (state = initialState, action) => {
    switch (action.type) {

        // ── GET STATUS ──────────────────────────────────────────────────────────
        case "REQUEST_GET_WHATSAPP_STATUS":
            return { ...state, isFetchingWhatsAppStatus: true };
        case "SUCCESS_GET_WHATSAPP_STATUS":
            return {
                ...state,
                whatsAppStatus: action.payload,
                socketStatus: action.payload.status,
                socketMessage: action.payload.message,
                isFetchingWhatsAppStatus: false,
            };
        case "ERROR_GET_WHATSAPP_STATUS":
            return { ...state, isFetchingWhatsAppStatus: false };

        // ── SEND MESSAGE ────────────────────────────────────────────────────────
        case "REQUEST_SEND_WHATSAPP_MESSAGE":
            return { ...state, isSendingWhatsAppMessage: true };
        case "SUCCESS_SEND_WHATSAPP_MESSAGE":
            return {
                ...state,
                sendMessageResponse: action.payload,
                isSendingWhatsAppMessage: false,
            };
        case "ERROR_SEND_WHATSAPP_MESSAGE":
            return { ...state, isSendingWhatsAppMessage: false };

        // ── SEND BULK ───────────────────────────────────────────────────────────
        case "REQUEST_SEND_BULK_WHATSAPP":
            return { ...state, isSendingBulkWhatsApp: true };
        case "SUCCESS_SEND_BULK_WHATSAPP":
            return {
                ...state,
                bulkMessageResults: action.payload.data,
                isSendingBulkWhatsApp: false,
            };
        case "ERROR_SEND_BULK_WHATSAPP":
            return { ...state, isSendingBulkWhatsApp: false };

        // ── SOCKET: real-time status update ────────────────────────────────────
        case "SET_WHATSAPP_SOCKET_STATUS":
            return {
                ...state,
                socketStatus: action.payload.status,
                socketMessage: action.payload.message,
                // Clear QR when we move past the 'qr' stage
                qrCode: action.payload.status === "connected" ? null : state.qrCode,
            };

        // ── SOCKET: new QR code received ────────────────────────────────────────
        case "SET_WHATSAPP_QR":
            return {
                ...state,
                qrCode: action.payload.qr,
                socketStatus: "qr",
            };

        default:
            return state;
    }
};

export default WhatsAppReducer;